<template>
    <div class="box-card pd-sm" v-if="isValid">
        <van-cell title="设置微信提醒" :value="remind?'已设置':'立即设置'" @click.native="openWxRemind" isLink>
            <template #icon>
                <van-icon name="bell" size="0.4rem"  style="" color="#DB3439" />
            </template>
        </van-cell>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {wxRemind} from "../../../api/wz/wx-remind";
    import {forEach} from "../../../utils/base"
    import {HOST_WEB} from "../../../const";
    const FUNC_TYPE_PAI = 1
    export default {
        name: "wx-remind",
        data(){
            return {
                remind : false
            }
        },
        computed : {
          ...mapGetters('account', ['isValid']),
            btnType(){
              return this.remind ? 'default' : 'danger'
            }
        },
        methods:{
            openWxRemind(){
                this.goSubWx()
            },
            hasSubWx(subs) {
                var yes = false
                if(subs) {
                    forEach(subs, item => {
                        if(item && item.funcType === FUNC_TYPE_PAI && item.status === 1) {
                            yes = true
                            this.remind = true
                        }
                    })
                }
                return yes
            },
            goSubWx() {
                let type = this.remind ? 'set' : '';
                location.href = 'https://' + HOST_WEB + '/message/sub/wx?funcType=' + FUNC_TYPE_PAI
            },
            loadWxRemind(){
                return wxRemind().then(R => {
                    this.hasSubWx(R.subs)
                }).catch(err => {
                    this.$toast(err.message || err.code);
                })
            }
        },
        mounted() {
            this.loadWxRemind()
        }
    }
</script>

<style scoped>

</style>